(function ($) {

	JdaVideoTools.BespokeEmbed = function ($elem, options) {

		/*##################################################################
		// Init
		##################################################################*/

        var scope = this;

        var loadingClass = 'loading';
        var loadedClass = 'loaded';

		this.$elem = $elem;
		this.$newElem = null;
		this.videoId = null;
		this.videoType = null;
		this.videoThumb = null;
		this.lastState = null;
		this.player = null;
		this.forceAspectRatio = false;
		this.thumbDimensions = null;
        this.playButtonText = 'Play';
        this.srPlayText = 'Play video';
        this.srPauseText = 'Stop video';

		this.settings = $.extend({
			// These are the defaults.
			wrapClass: '',
            idx: null,
			addGlobalEventFunction: function(eventKey, func) {
				if (eventKey == 'resize') {
					$(window).resize(function(e) {
						func(e);
					});
				}
				else if (eventKey == 'scroll') {
					$(window).scroll(function(e) {
						func(e);
					});
				} else {
					throw 'Invalid event event key: ' + eventKey;
				}
			}
		}, options);

		/*##################################################################
		// Methods
		##################################################################*/

        this.init = function () {

            // Work out text strings
            var playButtonText = $elem.data('play-label');
            if (playButtonText) scope.playButtonText = playButtonText;
            var srPlayText = $elem.data('screen-reader-play-label');
            if (srPlayText) scope.srPlayText = srPlayText;
            var srPauseText = $elem.data('screen-reader-pause-label');
            if (srPauseText) scope.srPauseText = srPauseText;

            // Work out video format details
			var details = JdaVideoTools.embedHelper.discernTypeAndId($elem.attr('href'));
			scope.videoType = details.type;
			scope.videoId = details.id;

            // Work out aspect ratio settings
			var far = $elem.data('force-aspect-ratio');
            if (far) {
                if (far == "true" || far === true) {
                    far = true;
                } else if (!far) {
                    far = false;
                } else if (far.indexOf('x') > -1) {
                    var arr = far.split('x');
                    var w = parseInt(arr[0]);
                    var h = parseInt(arr[1]);
                    far = {w: w, h: h};
                } else {
                    throw 'Invalid force-aspect-ratio value: ' + far;
                }
            }
            scope.forceAspectRatio = far;

            // Work out thumbnail settings
			var specifiedThumb = $elem.data('thumb');
			var thumbCallback = function(thumb) {
				scope.videoThumb = thumb;
				scope.$newElem = scope.replaceHtml();
				scope.discernHeightRatio(thumb, function(w, h, r) {
					scope.thumbDimensions = {w: w, h:h, r:r};
					scope.addEventListeners(scope.$newElem, scope.videoType);
					if (scope.forceAspectRatio) {
						scope.adjustHeight();
					}

                    // Use a short timeout to circumvent a race condition and ensure that the
                    // play button size is set.
					scope.setPlayBtnSizeClass();
                    setTimeout(function () {
					    scope.setPlayBtnSizeClass();
                    }, 250);
                    $elem.removeClass(loadingClass).addClass(loadedClass);
                    scope.$newElem.removeClass(loadingClass).addClass(loadedClass);
				});
			};
			if (specifiedThumb) {
				thumbCallback.call(null, specifiedThumb);
			} else {
				JdaVideoTools.embedHelper.discernThumb($elem, scope.videoType, scope.videoId, thumbCallback, false);
			}
		};

		this.addGlobalEventFunction = function(eventKey, func) {
			scope.settings.addGlobalEventFunction(eventKey, func);
		};

		this.discernTypeAndId = function(href) {
			return JdaVideoTools.embedHelper.discernTypeAndId(href);
		};

		this.getProtocol = function() {
			return JdaVideoTools.embedHelper.getProtocol();
		};

		this.getEmbedCode = function(videoType, videoId) {
			var id = this.getHtmlId();
            var frameTitle = this.srPlayText;
			return JdaVideoTools.embedHelper.getEmbedCode(videoType, videoId, id, frameTitle);
		}

		this.getHtmlId = function() {
			return scope.settings.idx;
		}

		this.discernHeightRatio = function(imgSrc, callback) {
			var img = new Image();
			img.src = imgSrc;
			img.onload = function() {
				var h = img.height;
				var w = img.width;
				var r = h/w;
				if (typeof callback !== 'undefined') {
					callback.call(null, w, h, r)
				}
			};
		};

		this.discernThumb = function(videoType, videoId, callback) {
		    return JdaVideoTools.embedHelper.discernThumb(this.$elem, videoType, videoId, callback, false);
		};

		this.replaceHtml = function() {
			var embedCode = scope.getEmbedCode(scope.videoType, scope.videoId);
			var html = [
                '<div class="jda-bespoke-embed-wrap ' + loadingClass + ' never-played paused ' + scope.settings.wrapClass + '" data-embed-type="' + scope.videoType + '" data-video-id="' + scope.videoId + '">',
					'<div class="mask-wrap">',
						'<button class="play-btn-wrap" tabindex="0" aria-label="' + scope.srPlayText + '">',
							'<div class="play-btn">',
								'<div class="play-btn-inner">',
									'<div class="play-img">',
										'<span class="glyph glyph-play" aria-hidden="true"></span>',
									'</div>',
									'<span class="play-text">' + scope.playButtonText + '</span>',
								'</div>',
							'</div>',
						'</button>',
						'<div class="bg-img" style="background-image: url(' + scope.videoThumb + ')"></div>',
					'</div>',
					'<div class="embed-wrap">',
						'<button class="pause-btn sr-only" tabindex="-1" aria-hidden="true">' + scope.srPauseText + '</button>',
						embedCode,
					'</div>',
				'</div>'
			];
			$elem.hide();
            var newElemHtml = html.join('');
            $elem.addClass(loadingClass).after(newElemHtml);
			var $newElem = $elem.next();
            $newElem.find('iframe').attr('aria-hidden', 'true').attr('tabindex', '-1');

		    $elem.trigger(EVENT_NAME__JDA_BESPOKE_EMBED__HTML_REPLACED, { $newElem: $newElem });
			return $newElem;
		};

		this.adjustHeight = function() {
			if ( (scope.forceAspectRatio === true) && (!scope.thumbDimensions)) {
				throw 'Cannot adjust height without having first discerned the height to width ratio.';
			}
            if (scope.forceAspectRatio === true) {
                var w = scope.$newElem.width();
                var h = w * scope.thumbDimensions.r;
            } else if (scope.forceAspectRatio) {
                var w = scope.$newElem.width();
                var h = (w / scope.forceAspectRatio.w) * scope.forceAspectRatio.h;
            }
            var hpx = Math.round(h) + 'px';
			var selsStr = [
				'.mask-wrap',
				'.play-btn-wrap',
				'.bg-img',
				'.embed-wrap',
				'iframe'
			].join(', ');
			var $elems = scope.$newElem.find(selsStr).addBack();
			$elems.css({
				height: hpx
			});
		};

		this.getPlayBtnSize = function() {
			var w = scope.$newElem.width();
			return w > 400 ? 'lg' : 'sm';
		};

		this.setPlayBtnSizeClass = function() {
			var size = scope.getPlayBtnSize();
			scope.$newElem.removeClass('play-btn-size-sm')
				.removeClass('play-btn-size-lg')
				.addClass('play-btn-size-' + size);
			scope.$newElem.find('.play-btn').removeClass('play-btn-sm')
				.removeClass('play-btn-lg')
				.addClass('play-btn-' + size);
		};

		this.addEventListeners = function($elem, embedType) {

			// vars
			var scope = this;
			var $iframe = $elem.find('iframe');
			var iframe = $iframe[0];
			var htmlId = $iframe.attr('id');

			// listeners
			scope.player = new JdaVideoTools.SourceAgnosticPlayer({
				videoData: {
					$iframeElem: $iframe,
					videoType: scope.videoType
				},
				eventData: {
                    onPlay: function () {
                        JdaVideoTools.BespokeEmbed.onPlay($elem);
					},
					onPause: function (data) {
                        $elem.find('iframe').attr('aria-hidden', 'true').attr('tabindex', '-1');
                        $elem.removeClass('playing')
                            .removeClass('play-pending')
                            .addClass('paused');
					    if (!data.ended) {
					        $elem.find('.play-btn-wrap').focus();
                            $elem.find('.pause-btn').addClass('hidden').attr('tabindex', '-1').attr('aria-hidden', 'true').focus();
					    }
					},
					onBuffering: function(duringPlayback) {
						duringPlayback = typeof duringPlayback !== 'undefined' ? duringPlayback : false;
						if (!duringPlayback) {
							$elem.removeClass('playing')
                                .addClass('paused')
								.addClass('play-pending');
						}
					}
				}
			});

			$elem.on('click', '.pause-btn', function() {
				scope.player.pause();
			});

			scope.addGlobalEventFunction('resize', function() {
				scope.adjustHeight();
				scope.setPlayBtnSizeClass();
			});

		}

		/*##################################################################
		// Chaining / init
		##################################################################*/

		this.init();
		return this;
	}

	$.fn.jdaBespokeEmbed = function (options) {
		return this.each(function () {
            $elem = $(this);
            options.idx = JdaVideoTools.embedManager.embeds.length;
            var embed = new JdaVideoTools.BespokeEmbed($elem, options);
            JdaVideoTools.embedManager.push(embed);
		});
    };

    JdaVideoTools.BespokeEmbed.onPlay = function ($elem) {
        $elem.find('iframe').removeAttr('aria-hidden').attr('tabindex', '0');
        $elem.removeClass('paused')
        $elem.removeClass('play-pending')
            .removeClass('never-played')
            .addClass('playing')
            .addClass('has-played');
        $elem.find('.pause-btn').removeClass('hidden').attr('tabindex', '0').removeAttr('aria-hidden').focus();
    };

}(jQuery));
